import { useAuthStore } from "@/store/auth-store";
import { Directive, DirectiveBinding } from "vue";
import { useRoute } from "vue-router";

export function permissionsDirective(): Directive {
  type BindingType = DirectiveBinding<string[]>;

  const authStore = useAuthStore();

  const route = useRoute();

  const permissionsDirectiveObject: Directive = {
    mounted(el: HTMLElement, binding: BindingType) {
      try {
        if (import.meta.env.DEV) return true;

        const { value, arg } = binding;

        if (arg === "sidebar") {
          const result = authStore.getPermissions.some((p) =>
            value.some((v) => v === p.name)
          );
          return (el.style.display = result ? "" : "none");
        }

        const permissions = authStore.getPagePermissions(route.name as string);

        const result = permissions.some((p) => value.some((v) => v === p.name));

        return (el.style.display = result ? "" : "none");
      } catch (error) {}
    },
    deep: true,
  };

  return permissionsDirectiveObject;
}

export default permissionsDirective;
